import { Link } from "@inertiajs/react";
import { CompanyLogo } from "@/components/CompanyLogo.tsx";
import { Card } from "@/components/ui/card.tsx";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table.tsx";
import { bizminer_app_account_root_path } from "@/routes";
import type { BizminerAccount } from "@/types/serializers";
import { LISTING_STATUS_LABELS } from "./listingStatus.ts";

interface AccountsTableProps {
  accounts: BizminerAccount[];
}

export function AccountsTable({ accounts }: AccountsTableProps) {
  return (
    <Card className="overflow-hidden p-0">
      <Table>
        <TableHeader className="bg-muted/50">
          <TableRow className="hover:bg-muted/50">
            <TableHead className="h-9 px-6 font-semibold text-xs uppercase tracking-wider">
              Account
            </TableHead>
            <TableHead className="h-9 px-6 font-semibold text-xs uppercase tracking-wider">
              Industry
            </TableHead>
            <TableHead className="h-9 px-6 font-semibold text-xs uppercase tracking-wider">
              Listing
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody className="[&_tr:last-child]:border-b">
          {accounts.map((account) => (
            <TableRow key={account.id}>
              <TableCell className="px-6 py-3.5">
                <Link
                  href={bizminer_app_account_root_path({
                    account_id: account.id,
                  })}
                  className="flex items-center gap-3 group"
                >
                  <CompanyLogo
                    logoUrl={account.logo_url}
                    name={account.name}
                    className="size-9 rounded-lg flex-shrink-0"
                  />
                  <span className="font-medium group-hover:text-primary transition-colors">
                    {account.name}
                  </span>
                </Link>
              </TableCell>
              <TableCell className="px-6 py-3.5 text-muted-foreground">
                {account.gics_classification?.name ?? "—"}
              </TableCell>
              <TableCell className="px-6 py-3.5 text-muted-foreground">
                {(account.listing_status &&
                  LISTING_STATUS_LABELS[account.listing_status]) ??
                  "—"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Card>
  );
}
